import InitialState from "./InitialState";
import { STORE_TEMPLATES_IDS_NAMES_MAP } from "../actions/ActionTypes";

export interface StaticTreatmentPlanInfo {
  treatmentPlansIdNameMap: { [key: string]: string }
}

export const StaticTreatmentPlanReducer = function (state = InitialState.treatmentPlanReducer, action: any) {
  switch (action.type) {
    case STORE_TEMPLATES_IDS_NAMES_MAP:
      const treatmentPlansIdNameMap: { [key: string]: string } = {}
      action.templatesArray.forEach((template: any) => {
        treatmentPlansIdNameMap[template.id] = template.templateName
      });
      return {
        ...state,
        treatmentPlansIdNameMap
      }
    default:
      return state;
  }
}